module.exports = __webpack_public_path__ + "img/d8ea56f.jpg";